import { HttpClient } from '@angular/common/http'
import { inject, Injectable } from '@angular/core'
import { environment } from '@monorepo-channels/shared/util-environments'
import { Observable } from 'rxjs'
const CONCIERGE_TOKEN = 'token_concierge'
const TOKEN_EXPIRATION = 'token_concierge_expiration'
const EXPIRATION_TIME = 60 * 60 * 1000

export interface LoginConciergeDto {
	username: string
	password: string
	partnerId: string
}

interface AccessToken {
	token: string
	createdAt: string
}

export interface LoginConciergeResponse {
	_id: string
	email: string
	username: string
	name: string
	lastName: string
	role: string
	access_token: AccessToken
}

@Injectable({ providedIn: 'root' })
export class ConciergeAuthService {
	public redirectURL = '/'
	private http = inject(HttpClient)
	private baseURL = `${environment.channelsAPIURL}/api/v1/auth/concierge`
	getToken() {
		const token = localStorage.getItem(CONCIERGE_TOKEN)
		const expiration = localStorage.getItem(TOKEN_EXPIRATION)

		if (!token || !expiration) {
			return null
		}

		const now = new Date().getTime()
		if (now > parseInt(expiration, 10)) {
			this.clearToken()
			return null
		}

		return token
	}

	setToken(token: string) {
		const expiration = new Date().getTime() + EXPIRATION_TIME
		localStorage.setItem(CONCIERGE_TOKEN, token)
		localStorage.setItem(TOKEN_EXPIRATION, expiration.toString())
	}

	clearToken() {
		localStorage.removeItem(CONCIERGE_TOKEN)
		localStorage.removeItem(TOKEN_EXPIRATION)
	}

	login(dto: LoginConciergeDto): Observable<LoginConciergeResponse> {
		return this.http.post<LoginConciergeResponse>(this.baseURL, dto)
	}
}
